export function toAmount(num: string | number) {
  return Number(num).toLocaleString();
}

export function toFixedAmount(num: string | number) {
  return Number(num).toLocaleString(undefined, { minimumFractionDigits: 2 });
}
